(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .controller('ConversationMessageReactionPanelController', ConversationMessageReactionPanelController);

    /* @ngInject */
    function ConversationMessageReactionPanelController(mdPanelRef, $scope, $state, $location, $mdDialog, $q, $filter, $mdToast, AlertService, ConversationModelService, Principal, Message, $mdPanel, $window, postMessageSecurity) {
        var vm = this;

        function handleEmoji(event) {
            if (!postMessageSecurity.isTrustedFirstPartyEmbedOrigin(event.origin)) {
                return;
            }
            var emoji = postMessageSecurity.parseTrustedEmojiPickerMessage(event.data);
            if (!emoji) {
                return;
            }
            mdPanelRef.emoji = emoji;
            mdPanelRef.close();
        }

        $window.addEventListener('message', handleEmoji, false);

        mdPanelRef.listenerFn = handleEmoji;

        $scope.$on('$destroy', function() {
            $window.removeEventListener('message', handleEmoji, false);
        });
    }
})();
